// Remembers when a password reset email was requested, so that
// password_reset_completed can report how long the user took. The reset link
// can be opened in another browser, in which case the time is unknown and the
// property is left off the event.
const STORAGE_KEY = "password-reset-requested-at"

export const rememberPasswordResetRequest = (email: string) => {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ email, requestedAt: Date.now() })
    )
  } catch (error) {
    console.error("failed to store the password reset request time", error)
  }
}

export const minutesSincePasswordResetRequest = (email: string) => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (!stored) return undefined

    const { email: requestedEmail, requestedAt } = JSON.parse(stored)
    if (requestedEmail !== email || typeof requestedAt !== "number") {
      return undefined
    }

    localStorage.removeItem(STORAGE_KEY)
    return Math.round((Date.now() - requestedAt) / 60000)
  } catch (error) {
    console.error("failed to read the password reset request time", error)
    return undefined
  }
}
